import { CalendarIcon } from 'lucide-react';

const Card = ({ children, className = "" }) => (
  <div className={`rounded-lg border bg-white shadow-sm ${className}`}>
    {children}
  </div>
);

const CardHeader = ({ children }) => (
  <div className="p-6 pb-0">{children}</div>
);

const CardTitle = ({ children, className = "" }) => (
  <h2 className={`text-2xl font-semibold leading-none tracking-tight ${className}`}>
    {children}
  </h2>
);

const CardContent = ({ children, className = "" }) => (
  <div className={`p-6 ${className}`}>{children}</div>
);

const Button = ({ children, onClick, className = "" }) => (
  <button
    onClick={onClick}
    className={`inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 ${className}`}
  >
    {children}
  </button>
);

const SalesFilter = ({startDate,setStartDate,endDate,setEndDate,fetchData,data}) => {
 

  return (
    <div className="w-full mx-auto">
      <Card>
        <CardHeader>
          <CardTitle>Sales Analytics</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Start Date
                </label>
                <div className="relative">
                  <CalendarIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="pl-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  End Date
                </label>
                <div className="relative">
                  <CalendarIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="pl-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-center">
              <Button 
                onClick={()=>fetchData()}
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-2 rounded-md text-sm"
              >
                View Sales
              </Button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Card className="bg-green-50">
                <CardContent className="pt-6">
                  <h3 className="text-lg font-medium text-green-800 mb-2">
                    Successful Sales
                  </h3>
                  <p className="text-3xl font-bold text-green-600">
                    ₹{Math.floor(data?.currentNetReceivedAmount)}
                  </p>
                </CardContent>
              </Card>

              <Card className="bg-red-50">
                <CardContent className="pt-6">
                  <h3 className="text-lg font-medium text-red-800 mb-2">
                    Failed Sales
                  </h3>
                  <p className="text-3xl font-bold text-red-600">
                    ₹{data?.currentFailedAmount}
                  </p>
                </CardContent>
              </Card>
              <Card className="bg-red-50">
                <CardContent className="pt-6">
                  <h3 className="text-lg font-medium text-indigo-600 mb-2">
                    All Time Platform Fee
                  </h3>
                  <p className="text-3xl font-bold text-indigo-600">
                    ₹{Math.floor(data?.allTimePlatformFeePaid)}
                  </p>
                </CardContent>
              </Card>
              <Card className="bg-red-50">
                <CardContent className="pt-6">
                  <h3 className="text-lg font-medium text-blue-500 mb-2">
                    Current Platform Fee
                  </h3>
                  <p className="text-3xl font-bold text-blue-500">
                    ₹{Math.ceil(data?.currentPlatformFeePaid)}
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SalesFilter;